import { useMemo } from 'react';
import type { GroupBase, StylesConfig } from 'react-select';

import { useGetAllGroups } from '~entities/groups';

import Select from '~shared/components/select/select';

export interface GroupOption {
  label: string;
  value: string;
}

export interface GroupSelectorProps {
  group:
    | {
        label: string;
        value: string;
      }
    | undefined
    | null;
  onChange: (
    value:
      | {
          label: string;
          value: string;
        }
      | undefined
      | null,
  ) => void;
  styles?: StylesConfig<unknown, boolean, GroupBase<unknown>> | undefined;
  disabled?: boolean;
  menuPortalTarget?: HTMLElement | null;
}

export const GroupSelector = ({
  group,
  onChange,
  styles,
  disabled = false,
  menuPortalTarget,
}: GroupSelectorProps) => {
  // const [searchQuery, setSearchQuery] = useState(group?.label ?? '');
  // const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const { data, isFetching } = useGetAllGroups();

  const options = useMemo(() => {
    const groups = data ?? [];
    let foundGroup = false;
    const optionsFromData = groups.map((g) => {
      if (g._id === group?.value) {
        foundGroup = true;
      }
      return { label: g.fieldName, value: g._id };
    });

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (group != null && !foundGroup) {
      optionsFromData.push({ label: group.label, value: group.value });
    }

    return optionsFromData;
  }, [data, group]);

  const currentGroup = data?.find((g) => g._id === group?.value);

  const currentOption = group
    ? {
        label: currentGroup?.fieldName ?? group.label,
        value: group.value || '',
      }
    : undefined;

  return (
    <Select
      isClearable
      value={currentOption}
      onChange={(option) => {
        const opt = option as GroupOption | null | undefined;
        onChange(opt);
      }}
      placeholder='Select Group'
      options={options}
      isLoading={isFetching}
      // onInputChange={(inputValue) => {
      //   setSearchQuery(inputValue);
      // }}
      styles={styles}
      isDisabled={disabled}
      menuPortalTarget={menuPortalTarget}
    />
  );
};
